import React, { useMemo } from "react";
import Switch from "react-switch";
import clsx from "clsx";
import PropTypes from "prop-types";
import { randomId } from "../../utils/utils";
import "./Toggle.scss";

const propTypes = {
  /**
   * Label text for toggle button
   */
  labelText: PropTypes.string,
  /**
   * Callback for when the toggle gets changed
   */
  onChange: PropTypes.func.isRequired,
  /**
   * set initial state of Toggle
   */
  checked: PropTypes.bool,
  /**
   * set Toggle disabled
   */
  disabled: PropTypes.bool,
  /**
   * Id of the switch
   */
  id: PropTypes.string,

  /**
   * Label style for toggle button
   */
  labelTextStyle: PropTypes.string,
};

const defaultProps = {
  labelText: "",
  checked: false,
  disabled: false,
  id: null,
  labelTextStyle: "",
};

/**
 * Toggle
 * Based on https://www.npmjs.com/package/react-switch.
 */
function Toggle(props) {
  const { labelText, onChange, checked, disabled, id, labelTextStyle } = props;

  const fallbackId = useMemo(() => randomId(), []);
  const switchId = id ?? `${fallbackId}-switch`;

  const toggleSwitch = (val) => {
    onChange(val);
  };

  return (
    <label htmlFor={switchId}>
      <span className={clsx(labelTextStyle, "Uic-Toggle-switch_label")}>
        {labelText}
      </span>
      <Switch
        onChange={(val) => toggleSwitch(val)}
        checked={checked}
        disabled={disabled}
        className={
          checked
            ? clsx("Uic-Toggle-react_switch")
            : clsx("Uic-Toggle-react_switch_off")
        }
        id={switchId}
        uncheckedIcon={false}
        checkedIcon={false}
        height={14}
        width={34}
        handleDiameter={18}
      />
    </label>
  );
}

Toggle.propTypes = propTypes;
Toggle.defaultProps = defaultProps;

export default Toggle;
